import React, { Fragment, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';

import UploadIcon from '../../../../../../../../components/icons/UploadIcon';
import useAssetImageUpload from '../../../../../../../../hooks/useAssetImageUpload';
import Button from '../../../../../../../../components/global/Button';
import { fileInputAccept } from '../../../../../../../../constants/photo-upload';
import { getMaxThumb } from '../../../../../../../../util/photo';
import PhotoUploadCache from '../../../../../../../../components/product/PhotoUploadCache';
import { MeQuery } from '../../../../../../../../graphql/queries/account';

const propTypes = {
  account: PropTypes.shape({
    id: PropTypes.string,
    logo_image: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  introImage: PropTypes.shape({
    id: PropTypes.string,
    thumbnail_urls: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        width: PropTypes.number,
      }),
    ),
  }),
  onInsertIntroSlide: PropTypes.func,
  onRequestClose: PropTypes.func.isRequired,
};
const IntroSlideSelect = ({
  account,
  introImage,
  onInsertIntroSlide,
  onRequestClose,
}) => {
  const introImageRef = useRef(null);
  const [previewImage, setPreviewImage] = useState(introImage);
  const [saving, setSaving] = useState(false);
  const { uploading, onUpload } = useAssetImageUpload({
    onImageUploaded: async assetImage => {
      setPreviewImage(assetImage);
      setSaving(true);
      await onInsertIntroSlide({ assetImage, existing: false });
      setSaving(false);
      onRequestClose();
    },
  });

  return (
    <Fragment>
      <h4>Upload an image</h4>
      <Button
        btnStyle="info"
        btnBlock
        onClick={() => introImageRef.current.click()}
        disabled={uploading || saving}
        className="text-primary d-flex align-items-center text-bold mb-2"
      >
        {/* eslint-disable-next-line no-nested-ternary */}
        {uploading ? (
          'Uploading...'
        ) : saving ? (
          'Saving...'
        ) : (
          <Fragment>
            <UploadIcon className="mr-1" color="#0d84fe" size={18} />
            Upload an image
          </Fragment>
        )}
      </Button>
      <input
        id="intro-slide-image"
        ref={introImageRef}
        type="file"
        className="d-none"
        accept={fileInputAccept}
        onChange={event => {
          const [file] = event.target.files;
          onUpload(file);
        }}
        disabled={uploading}
        value=""
      />
      {previewImage && (
        <Fragment>
          <PhotoUploadCache
            id={previewImage.id}
            thumbs={previewImage.thumbnail_urls}
            render={thumbs => (
              <div className="intro-slide-image-preview">
                <img src={getMaxThumb(thumbs).url} alt="" />
              </div>
            )}
          />
        </Fragment>
      )}
      {account?.logo_image && onInsertIntroSlide && (
        <Fragment>
          <h4>Use my logo</h4>
          <div className="intro-slide-image-preview">
            <img src={account.logo_image.url} alt="" />
          </div>
          <div className="text-center">
            <Button
              disabled={saving}
              onClick={async () => {
                setSaving(true);
                await onInsertIntroSlide({
                  assetImage: account.logo_image,
                  existing: true,
                });
                setSaving(false);
                onRequestClose();
              }}
            >
              {saving ? 'Saving...' : 'Insert'}
            </Button>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

const withMeQuery = graphql(MeQuery, {
  props: ({ data: { me } }) => ({
    account: me,
  }),
});

IntroSlideSelect.propTypes = propTypes;

export default compose(withMeQuery)(IntroSlideSelect);
